// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baloa-pro-payment-methods-modal .modal2__container {
    width: 486px;
}

.baloa-pro-payment-methods-modal__content {
    padding: 18px 40px 24px 40px;
}

.baloa-pro-payment-methods-modal__label.baloa-username {
    color: var(--primary-very-dark-color);
}

.baloa-pro-payment-methods-modal__payment-method {
    border-bottom: 1px solid var(--new-background-color);
    padding: 16px 0;
    display: flex;
    align-items: center;
}

.baloa-pro-payment-methods-modal__payment-method-name.baloa-table {
    font-weight: var(--font-medium);
    color: var(--primary-very-dark-color);
    text-transform: capitalize;
}

.baloa-pro-payment-methods-modal__method-principal.baloa-username {
    color: var(--primary-dark-color);
}

.baloa-pro-payment-methods-modal__radio.MuiButtonBase-root.MuiRadio-root.Mui-checked {
    color: var(--new-green-color);
}

.baloa-pro-payment-methods-modal__buttons {
    margin-top: 24px;
}

.baloa-pro-payment-methods-modal__buttons .button.small {
    padding: 8px 6px;
}

.baloa-pro-payment-methods-modal__buttons .icon {
    grid-area: icon;
}

.baloa-pro-payment-methods-modal__buttons .hubicon-add_option{
    font-size: 20px;
}

.baloa-pro-payment-methods-modal__save-button {
    border-top: 1px solid var(--new-background-color);
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.baloa-pro-payment-methods-modal__save-button .button.small {
    padding: 10px 20px;
}


@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .baloa-pro-payment-methods-modal .modal2__container {
        width: 100%;
        margin: 0;
        height: 100%;
        max-height: unset;
        border-radius: 0;
        background: var(--white-color);
    }

    .baloa-pro-payment-methods-modal .modal2__content {
        height: 100%;
    }

    .baloa-pro-payment-methods-modal .modal2__header__title.baloa-subtitle-2 {
        font-size: 18px;
    }

    .baloa-pro-payment-methods-modal__label.baloa-username {
        font-size: 15px;
    }

    .baloa-pro-payment-methods-modal__content {
        padding: 25px 20px 24px 20px;
    }

    .baloa-pro-payment-methods-modal__payment-method-name.baloa-table {
        font-size: 16px;
    }

    .baloa-pro-payment-methods-modal__buttons .button.small {
        font-size: 15px;
    }

    .baloa-pro-payment-methods-modal__payment-method {
        border-bottom: 1px solid var(--new-gray-background-color);
    }
}`, "",{"version":3,"sources":["webpack://./src/app/baloa-pro/components/baloa-pro-payment-methods-modal/BaloaProPaymentMethodsModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,oDAAoD;IACpD,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,qCAAqC;IACrC,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iDAAiD;IACjD,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;;AAGA,yCAAyC,4BAA4B;;IAEjE;QACI,WAAW;QACX,SAAS;QACT,YAAY;QACZ,iBAAiB;QACjB,gBAAgB;QAChB,8BAA8B;IAClC;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,yDAAyD;IAC7D;AACJ","sourcesContent":[".baloa-pro-payment-methods-modal .modal2__container {\n    width: 486px;\n}\n\n.baloa-pro-payment-methods-modal__content {\n    padding: 18px 40px 24px 40px;\n}\n\n.baloa-pro-payment-methods-modal__label.baloa-username {\n    color: var(--primary-very-dark-color);\n}\n\n.baloa-pro-payment-methods-modal__payment-method {\n    border-bottom: 1px solid var(--new-background-color);\n    padding: 16px 0;\n    display: flex;\n    align-items: center;\n}\n\n.baloa-pro-payment-methods-modal__payment-method-name.baloa-table {\n    font-weight: var(--font-medium);\n    color: var(--primary-very-dark-color);\n    text-transform: capitalize;\n}\n\n.baloa-pro-payment-methods-modal__method-principal.baloa-username {\n    color: var(--primary-dark-color);\n}\n\n.baloa-pro-payment-methods-modal__radio.MuiButtonBase-root.MuiRadio-root.Mui-checked {\n    color: var(--new-green-color);\n}\n\n.baloa-pro-payment-methods-modal__buttons {\n    margin-top: 24px;\n}\n\n.baloa-pro-payment-methods-modal__buttons .button.small {\n    padding: 8px 6px;\n}\n\n.baloa-pro-payment-methods-modal__buttons .icon {\n    grid-area: icon;\n}\n\n.baloa-pro-payment-methods-modal__buttons .hubicon-add_option{\n    font-size: 20px;\n}\n\n.baloa-pro-payment-methods-modal__save-button {\n    border-top: 1px solid var(--new-background-color);\n    padding: 12px 16px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.baloa-pro-payment-methods-modal__save-button .button.small {\n    padding: 10px 20px;\n}\n\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .baloa-pro-payment-methods-modal .modal2__container {\n        width: 100%;\n        margin: 0;\n        height: 100%;\n        max-height: unset;\n        border-radius: 0;\n        background: var(--white-color);\n    }\n\n    .baloa-pro-payment-methods-modal .modal2__content {\n        height: 100%;\n    }\n\n    .baloa-pro-payment-methods-modal .modal2__header__title.baloa-subtitle-2 {\n        font-size: 18px;\n    }\n\n    .baloa-pro-payment-methods-modal__label.baloa-username {\n        font-size: 15px;\n    }\n\n    .baloa-pro-payment-methods-modal__content {\n        padding: 25px 20px 24px 20px;\n    }\n\n    .baloa-pro-payment-methods-modal__payment-method-name.baloa-table {\n        font-size: 16px;\n    }\n\n    .baloa-pro-payment-methods-modal__buttons .button.small {\n        font-size: 15px;\n    }\n\n    .baloa-pro-payment-methods-modal__payment-method {\n        border-bottom: 1px solid var(--new-gray-background-color);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
